module.exports = __webpack_public_path__ + "media/wan prá wan jâo mâi wáyn gan lóie.1cf8ad39.mp3";